import request from '@/utils/request'


// 查询月卡申请
export function getMonthlyApplyInfo(id) {
  return request({
    url: '/parking/monthlyCardApply/getMonthlyCardAndAuditByApplyId/' + id,
    method: 'get'
  })
}

// 新增月卡申请
export function addMonthlyApply(data) {
  return request({
    url: '/parking/monthlyCardApply/addMobile',
    method: 'post',
    data: data
  })
}

// 修改月卡申请
export function updateMonthlyApply(data) {
  return request({
    url: '/parking/monthlyCardApply/updateMobile',
    method: 'post',
    data: data
  })
}


// 查询我的月卡
export function selectMyMonthlyCard(data) {
  return request({
    url: '/parking/monthlyCardApply/selectMyMonthlyCard',
    method: 'post',
    data: data
  })
}

// 根据停车场ID和社区类型查询认证配置
export function getCertificationsByParkingAndType(parkingSpaceId, communityType) {
  return request({
    url: `/parking/monthlycardcertsetting/listByParking/${parkingSpaceId}/${communityType}`,
    method: 'get'
  })
}
